import "firebase/compat/analytics"
import "firebase/compat/auth"
import "firebase/compat/firestore"
import "firebase/compat/messaging"
import "firebase/compat/functions"
import "firebase/compat/storage"

import firebase from "firebase/compat/app"

export const analytics = () => {
  const analytics1 = firebase.analytics()
  // @ts-ignore
  analytics1.logScreenView = (currentScreen: string) => analytics1.setCurrentScreen(currentScreen)
  return analytics1
}
export const auth = () => {
  const auth1 = firebase.auth()
  // @ts-ignore
  auth1.onUserChanged = auth1.onIdTokenChanged
  // @ts-ignore
  auth1.RecaptchaVerifier = (...params) => new firebase.auth.RecaptchaVerifier(...params)
  return auth1
}
export const firestore = firebase.firestore
export const messaging = firebase.messaging
export const crashlytics = () => ({
  // eslint-disable-next-line no-console
  recordError: console.log,
})
// Configure the functions to use europe-west1 region
export const functions = () => firebase.app().functions("europe-west1")
export const storage = firebase.storage
export const PhoneAuthProvider = firebase.auth.PhoneAuthProvider
export const PhoneMultiFactorGenerator = firebase.auth.PhoneMultiFactorGenerator
export const multiFactor = (user: any) => user.multiFactor
export const getMultiFactorResolver = (_, error: any) => error.resolver
export default firebase
